.container {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 24px 16px;
  box-sizing: border-box;
  margin-top: 40px;
}

.title {
  text-align: center;
  font-size: 22px;
  color: #ffffff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

.progressWrapper {
  position: relative;
  height: 28px;
  border-radius: 9999px;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
}

.progressBlurBackground {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(6px);
  z-index: 1;
}

.progressFill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(to right, #ff99cc, #ff6677);
  transition: width 0.5s ease-out;
  border-radius: 9999px;
  z-index: 2;
}

.progressText {
  position: relative;
  z-index: 3;
  width: 100%;
  text-align: center;
  font-size: 18px;
  color: #ffffff;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
}

.second-type.container {
  margin-top: 0;
}

.second-type {
  width: 100%;
}

.second-type * {
  color: #121212;
  text-shadow: none!important;
  box-shadow: none!important;
}

.second-type .progressWrapper {
  border: 1px solid #121212;
}

.second-type .title {
  font-size: 21px;
}

.second-type .progressText {
  font-size: 16px;
}